import {
  HurricanesLogo,
  JetsLogo,
  PackersLogo,
  RevsLogo,
  TexansLogo,
  UtesLogo,
  VGKLogo,
  WildLogo,
} from '@/assets'

export const partners = [
  {
    url: 'https://packers.bookseats.com/',
    img: PackersLogo,
    name: 'Green Bay Packers',
  },
  {
    url: 'https://newyorkjets.bookseats.com/',
    img: JetsLogo,
    name: 'New York Jets',
  },
  {
    url: 'https://houstontexans.bookseats.com/',
    img: TexansLogo,
    name: 'Houston Texans',
  },
  {
    url: 'https://vegasgoldenknights.bookseats.com/',
    img: VGKLogo,
    name: 'Vegas Golden Knights',
  },
  {
    url: 'https://hurricanes.bookseats.com/',
    img: HurricanesLogo,
    name: 'Carolina Hurricanes',
  },
  {
    url: 'https://wild.bookseats.com/',
    img: WildLogo,
    name: 'Minnesota Wild',
  },
  {
    url: 'https://utes.bookseats.com/',
    img: UtesLogo,
    name: 'Utah Utes',
  },
  {
    url: 'https://revolution.bookseats.com/',
    img: RevsLogo,
    name: 'New England Revolution',
  },
]
